import styled from 'styled-components';

export const PageWrapStyles = styled.div`
  position: relative;
  width: calc(100% - 4px);
  max-width: 960px;
  margin: 0 auto;
  padding: 2px;
`;
